import {
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  Input,
  Box,
  Flex,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { MdDelete, MdEdit } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import {
  getStudentPaymentsRequest,
  editStudentPaymentRequest,
  deleteStudentPaymentRequest,
} from "../../../modules/admin-modules/payment/Actions";
import { openEditStudentPaymentModel } from "../../../modules/admin-modules/models/Actions";
import EditStudentPayment from "./models/edit-student-payment";

const StudentPaymentsTable = () => {
  const studentPayments = useSelector((state) => state.payments.studentPayments);
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.payments.isLoading);
  const count = useSelector((state) => state.payments.count);

  const [searchTerm, setSearchTerm] = useState("");
  const [selected, setSelected] = useState({
    id: "",
  });
  const [selectedPayment, setSelectedPayment] = useState({});

  useEffect(() => {
    const timeId = setTimeout(() => {
      dispatch(getStudentPaymentsRequest(searchTerm || null));
    }, 500);

    return () => {
      clearTimeout(timeId);
    };
  }, [searchTerm]);

  const viewData = (data) => {
    setSelected(data);
  };

  const Data = Array.isArray(studentPayments?.data?.data) ? studentPayments.data.data.map((data, index) => {
    return {
      ...data,
      index: `#${index + 1}`,
      id: data?.id,
      student_name: data?.student?.name || "N/A",
      phone: data?.student?.phone || "N/A",
      payment_subject_name: data?.payment_subject?.name || "N/A",
      amount: data?.paid_amount || "N/A",
      remaining_amount: data?.remaining_amount || "0",
      payment_date: data?.created_at ? new Date(data.created_at).toLocaleDateString('ar-EG') : "N/A",
      comment: data?.comment || "N/A",
      status: data?.is_paid ? "مدفوع" : "غير مدفوع",
      edit: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Edit Payment"
          fontSize="20px"
          icon={<MdEdit />}
          onClick={() => {
            setSelectedPayment(data);
            dispatch(openEditStudentPaymentModel());
          }}
        />
      ),
      delete: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Delete Payment"
          fontSize="20px"
          icon={<MdDelete />}
          onClick={() => {
            setSelected({ id: data?.id });
            dispatch(deleteStudentPaymentRequest(data?.id));
          }}
          isLoading={selected.id === data?.id ? isLoading : false}
        />
      ),
    };
  }) : [];

  const columns = [
    {
      Header: "رقم",
      accessor: "index",
    },
    {
      Header: "اسم الطالب",
      accessor: "student_name",
    },
    {
      Header: "رقم الهاتف",
      accessor: "phone",
    },
    {
      Header: "المادة",
      accessor: "payment_subject_name",
    },
    {
      Header: "المبلغ المدفوع",
      accessor: "amount",
    },
    {
      Header: "المبلغ المتبقي",
      accessor: "remaining_amount",
    },
    {
      Header: "تاريخ الدفع",
      accessor: "payment_date",
    },
    {
      Header: "ملاحظات",
      accessor: "comment",
    },
    {
      Header: "الحالة",
      accessor: "status",
    },
    {
      Header: "تعديل",
      accessor: "edit",
    },
    {
      Header: "حذف",
      accessor: "delete",
    },
  ];

  const searchBar = (
    <Box w="100%" mb={4}>
      <Flex direction="column" gap={2}>
        <Text fontSize="lg" fontWeight="bold" color="main_1">
          البحث برقم الهاتف
        </Text>
        <Input
          placeholder="ادخل رقم الهاتف للبحث..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          bg="white"
          border="1px solid #e2e8f0"
          borderRadius="8px"
          _focus={{
            borderColor: "main_1",
            boxShadow: "0 0 0 1px main_1",
          }}
        />
      </Flex>
    </Box>
  );

  return (
    <Box w="100%">
      {searchBar}
      <CTable
        selectedData={viewData}
        Columns={columns}
        Data={Data}
        path={"openModel"}
        Title="مدفوعات الطلاب"
        subTitle=""
        btnTitle=""
        placeHolder=""
        noSearchBar={true}
        noFilter={true}
        footerBtnTitle
        filterList
        addButton
        addButtonTitle=""
        noSecondSearchBar={true}
        isLoading={isLoading}
        perPage={10}
        totalPage={Math.ceil(count / 10)}
      />
      <EditStudentPayment 
        data={selectedPayment} 
        setSelectedData={setSelectedPayment} 
      />
    </Box>
  );
};

export default StudentPaymentsTable; 